export const SET_CONVERSATIONS = 'SET_CONVERSATIONS';
export const SET_CURRENT_CONVERSATION = 'SET_CURRENT_CONVERSATION';
export const SET_PAGINATION_CONVERSATIONS = 'SET_PAGINATION_CONVERSATIONS';
export const SET_DATA_CURRENT_CONVERSATION = 'SET_DATA_CURRENT_CONVERSATION';
export const SET_MESSAGES_HISTORY = 'SET_MESSAGES_HISTORY';
export const SET_PAGINATION_MESSAGES_HISTORY = 'SET_PAGINATION_MESSAGES_HISTORY';
export const SET_BABY_ID = 'SET_BABY_ID';
export const RESET_CHAT = 'RESET_CHAT';
export const SET_IS_SCROLL_TO_BOTTOM_LIST_CHAT = 'SET_IS_SCROLL_TO_BOTTOM_LIST_CHAT';
export const SET_LOADING_SCREEN_CHAT = 'SET_LOADING_SCREEN_CHAT';
